if (!customElements.get('glyc-pdp-gallery')) {
  customElements.define(
    'glyc-pdp-gallery',
    class GlycPdpGallery extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-glyc-gallery-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-glyc-gallery-thumb]')];
        this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('glyc-pdp-gallery__slide--active'));
        if (this.currentIndex < 0) this.currentIndex = 0;

        this.counterCurrent = this.querySelector('[data-glyc-gallery-current]');
        this.dialog = this.querySelector('[data-glyc-gallery-dialog]');
        this.dialogContent = this.querySelector('[data-glyc-gallery-dialog-content]');
        this.touchStartX = 0;
        this.touchStartY = 0;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.index)));
        });

        this.querySelector('[data-glyc-gallery-prev]')?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.querySelector('[data-glyc-gallery-next]')?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

        this.querySelectorAll('[data-glyc-gallery-fullscreen]').forEach((button) => {
          button.addEventListener('click', () => this.openFullscreen(this.currentIndex));
        });

        this.querySelector('[data-glyc-gallery-dialog-close]')?.addEventListener('click', () => this.closeFullscreen());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closeFullscreen();
        });
        this.dialog?.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeFullscreen();
        });

        const slidesContainer = this.querySelector('.glyc-pdp-gallery__slides');
        slidesContainer?.addEventListener('touchstart', (event) => this.onTouchStart(event), { passive: true });
        slidesContainer?.addEventListener('touchend', (event) => this.onTouchEnd(event), { passive: true });

        this.addEventListener('keydown', (event) => this.onKeydown(event));
        this.resetAllImageZoom();
        this.initZoom();
      }

      resetImageZoom(image) {
        if (!image) return;
        image.style.transform = '';
        image.style.transformOrigin = '';
      }

      resetAllImageZoom() {
        this.querySelectorAll('.glyc-pdp-gallery__image').forEach((image) => this.resetImageZoom(image));
      }

      initZoom() {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

        this.querySelectorAll('[data-glyc-gallery-zoom]').forEach((zoomRoot) => {
          const image = zoomRoot.querySelector('.glyc-pdp-gallery__image');
          if (!image) return;

          this.resetImageZoom(image);

          zoomRoot.addEventListener('mouseenter', () => {
            zoomRoot.dataset.glycZoomActive = 'true';
          });

          zoomRoot.addEventListener('mousemove', (event) => {
            if (zoomRoot.dataset.glycZoomActive !== 'true') return;

            const rect = zoomRoot.getBoundingClientRect();
            const x = ((event.clientX - rect.left) / rect.width) * 100;
            const y = ((event.clientY - rect.top) / rect.height) * 100;
            image.style.transformOrigin = `${x}% ${y}%`;
            image.style.transform = 'scale(2)';
          });

          zoomRoot.addEventListener('mouseleave', () => {
            zoomRoot.dataset.glycZoomActive = 'false';
            this.resetImageZoom(image);
          });
        });
      }

      goTo(index) {
        if (!this.slides.length) return;

        const nextIndex = (index + this.slides.length) % this.slides.length;
        if (nextIndex === this.currentIndex) return;

        this.slides[this.currentIndex]?.classList.remove('glyc-pdp-gallery__slide--active');
        this.slides[this.currentIndex]?.setAttribute('hidden', '');

        this.currentIndex = nextIndex;

        this.slides[this.currentIndex]?.classList.add('glyc-pdp-gallery__slide--active');
        this.slides[this.currentIndex]?.removeAttribute('hidden');

        this.thumbs.forEach((thumb) => {
          const isActive = Number(thumb.dataset.index) === this.currentIndex;
          thumb.classList.toggle('glyc-pdp-gallery__thumb--active', isActive);
          thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        if (this.counterCurrent) {
          this.counterCurrent.textContent = String(this.currentIndex + 1);
        }

        this.resetAllImageZoom();
        this.pauseInactiveVideos();
      }

      goToMediaId(mediaId) {
        const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
        if (index >= 0) this.goTo(index);
      }

      pauseInactiveVideos() {
        this.querySelectorAll('video').forEach((video) => {
          if (!video.closest('.glyc-pdp-gallery__slide--active')) {
            video.pause();
          }
        });
      }

      onTouchStart(event) {
        const touch = event.changedTouches[0];
        this.touchStartX = touch.screenX;
        this.touchStartY = touch.screenY;
      }

      onTouchEnd(event) {
        const touch = event.changedTouches[0];
        const deltaX = touch.screenX - this.touchStartX;
        const deltaY = touch.screenY - this.touchStartY;

        if (Math.abs(deltaX) < 40 || Math.abs(deltaY) > Math.abs(deltaX)) return;

        if (deltaX < 0) {
          this.goTo(this.currentIndex + 1);
        } else {
          this.goTo(this.currentIndex - 1);
        }
      }

      onKeydown(event) {
        if (!this.contains(document.activeElement)) return;

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.currentIndex + 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.currentIndex - 1);
        }
      }

      openFullscreen(index) {
        if (!this.dialog || !this.dialogContent) return;

        const slide = this.slides[index];
        const image = slide?.querySelector('.glyc-pdp-gallery__image');
        if (!image) return;

        this.dialogContent.innerHTML = '';
        const clone = image.cloneNode(true);
        clone.removeAttribute('style');
        clone.classList.add('glyc-pdp-gallery__dialog-image');
        clone.loading = 'eager';
        this.dialogContent.appendChild(clone);

        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
      }

      closeFullscreen() {
        if (!this.dialog) return;

        if (this.dialog.open) {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
        }
        if (this.dialogContent) this.dialogContent.innerHTML = '';
      }
    }
  );
}

if (!customElements.get('glyc-pdp-sticky')) {
  customElements.define(
    'glyc-pdp-sticky',
    class GlycPdpSticky extends HTMLElement {
      connectedCallback() {
        this.purchasePanel = document.querySelector('[data-glyc-pdp-purchase]');
        this.submitButton = document.querySelector('[data-glyc-pdp-submit]');
        this.stickySubmit = this.querySelector('[data-glyc-sticky-submit]');
        this.stickyPriceAmount = this.querySelector('[data-glyc-sticky-price-amount]');
        this.stickyPriceCompare = this.querySelector('[data-glyc-sticky-price-compare]');
        this.variantStrings = window.variantStrings || {};

        if (!this.purchasePanel) return;

        this.setVisible(false);

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.setVisible(!entry.isIntersecting);
          },
          { threshold: 0, rootMargin: '0px' }
        );

        this.observer.observe(this.purchasePanel);

        this.stickySubmit?.addEventListener('click', () => {
          if (this.stickySubmit.hasAttribute('disabled')) return;
          this.submitButton?.click();
        });

        document.addEventListener('glyc:variant-change', (event) => {
          this.updateFromVariant(event.detail?.variant);
        });
      }

      setVisible(isVisible) {
        this.classList.toggle('glyc-pdp-sticky--visible', isVisible);
        this.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

        if (isVisible) {
          this.removeAttribute('inert');
        } else {
          this.setAttribute('inert', '');
        }
      }

      updateFromVariant(variant) {
        if (!this.stickySubmit) return;

        if (!variant) {
          this.updateStickyPrice(null);
          this.stickySubmit.textContent = this.variantStrings.unavailable || 'Unavailable';
          this.stickySubmit.setAttribute('disabled', 'disabled');
          return;
        }

        this.updateStickyPrice(variant);

        if (variant.available) {
          this.stickySubmit.textContent = this.variantStrings.addToCart || 'Add to cart';
          this.stickySubmit.removeAttribute('disabled');
        } else {
          this.stickySubmit.textContent = this.variantStrings.soldOut || 'Sold out';
          this.stickySubmit.setAttribute('disabled', 'disabled');
        }
      }

      updateStickyPrice(variant) {
        if (!this.stickyPriceAmount) return;

        if (!variant) {
          this.stickyPriceAmount.textContent = '';
          if (this.stickyPriceCompare) {
            this.stickyPriceCompare.textContent = '';
            this.stickyPriceCompare.hidden = true;
          }
          return;
        }

        this.stickyPriceAmount.textContent = variant.price_formatted;

        if (this.stickyPriceCompare) {
          if (variant.compare_at_price > variant.price) {
            this.stickyPriceCompare.textContent = variant.compare_at_price_formatted;
            this.stickyPriceCompare.hidden = false;
          } else {
            this.stickyPriceCompare.textContent = '';
            this.stickyPriceCompare.hidden = true;
          }
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('glyc-pdp-gallery');

  document.addEventListener('glyc:variant-change', (event) => {
    const variant = event.detail?.variant;
    if (gallery && variant?.featured_media_id) {
      gallery.goToMediaId(variant.featured_media_id);
    }
    updateSavingsBadge(variant);
  });
});

function updateSavingsBadge(variant) {
  document.querySelectorAll('[data-glyc-savings-root]').forEach((badge) => {
    if (!variant || variant.compare_at_price <= variant.price) {
      badge.hidden = true;
      badge.classList.add('glyc-pdp-savings--hidden');
      return;
    }

    const savingsPercent = Math.round(
      ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
    );
    badge.textContent = badge.dataset.savingsTemplate
      ? badge.dataset.savingsTemplate.replace('[[percent]]', String(savingsPercent))
      : `Save ${savingsPercent}%`;
    badge.hidden = false;
    badge.classList.remove('glyc-pdp-savings--hidden');
  });
}
